// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { Pressable, StyleSheet, View } from 'react-native';
import { useRouter } from 'expo-router';

import { Text } from '@/components/Themed';
import appColors from '@/theme/colors';

export default function TourEditFallbackScreen() {
  const router = useRouter();

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Tour Edit</Text>
      <Text style={styles.subtitle}>This page is only available on web.</Text>
      <Pressable style={styles.backButton} onPress={() => router.back()}>
        <Text style={styles.backText}>Go back</Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    backgroundColor: appColors.background.app,
    padding: 24,
  },
  title: {
    color: appColors.text.primary,
    fontSize: 22,
    fontWeight: '800',
  },
  subtitle: {
    color: appColors.text.muted,
    textAlign: 'center',
  },
  backButton: {
    marginTop: 8,
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 999,
    borderWidth: 1,
    borderColor: appColors.accent.subtleBorder,
    backgroundColor: appColors.accent.subtleBg,
  },
  backText: {
    color: appColors.text.primary,
    fontWeight: '700',
    fontSize: 12,
  },
});
